import { TrainingTranslationsController } from './training-translations.controller';

/**
 * Remembers the language tab an author picked, per training id, so the choice survives
 * navigation between that training's pages. Session-only: plain memory, gone on a reload.
 */
export class SelectedTrainingLanguageStore {
  private readonly byTrainingId = new Map<string, string>();

  /** Last picked tab. The source language overwrites an earlier translation language. */
  set(trainingId: string, language: string): void {
    if (trainingId) {
      // Ids arrive as strings from some records and numbers from others —
      // normalize so every page addresses the same entry.
      this.byTrainingId.set(String(trainingId), language);
    }
  }

  /** The stored tab for a training; '' when it has none. */
  get(trainingId: string): string {
    return trainingId ? (this.byTrainingId.get(String(trainingId)) ?? '') : '';
  }
}

/**
 * Re-enters the stored translation tab once a page has initialized its controller.
 * `select` must be the page's own tab-click handler, so an auto-restore runs exactly
 * the side effects a real click runs. A stored language the training no longer has —
 * or the source itself — leaves the source tab selected.
 */
export const restoreSelectedLanguage = (
  controller: TrainingTranslationsController,
  storedLanguage: string,
  select: (language: string) => void,
): void => {
  if (
    !storedLanguage ||
    storedLanguage === controller.sourceLanguage ||
    !controller.translationLanguages.includes(storedLanguage)
  ) {
    return;
  }
  select(storedLanguage);
};
